import {
  SettingOutlined,
  UserAddOutlined,
  ScheduleOutlined,
  ApartmentOutlined,
  BankOutlined,
  CloudServerOutlined,
  AuditOutlined,
  FileTextOutlined,
  UnorderedListOutlined,
  TeamOutlined,
  LinkOutlined,
  UserOutlined,
  CalendarOutlined,
  FieldTimeOutlined,
  CheckCircleOutlined,
  BarChartOutlined,
  DashboardOutlined,
  // FileSearchOutlined,
  SnippetsOutlined,
} from "@ant-design/icons";
import { APP_PREFIX_PATH } from "../configs/AppConfig";

const componentsNavTree = [
  {
    key: "analytics",
    path: `${APP_PREFIX_PATH}/analytics`,
    title: "sidenav.analytics",
    icon: BarChartOutlined,
    breadcrumb: true,
    submenu: [
      {
        key: "analytics-obligation-overview",
        path: `${APP_PREFIX_PATH}/analytics/obligation-overview`,
        title: "sidenav.obligation-overview",
        icon: DashboardOutlined,
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "analytics-reports",
        path: `${APP_PREFIX_PATH}/analytics/reports`,
        title: "sidenav.analytics-reports",
        icon: SnippetsOutlined,
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "analytics-report-status",
        path: `${APP_PREFIX_PATH}/analytics/reports/status`,
        title: "sidenav.report-status",
        icon: BarChartOutlined,
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "analytics-report-priority",
        path: `${APP_PREFIX_PATH}/analytics/reports/priority`,
        title: "sidenav.report-priority",
        icon: BarChartOutlined,
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "analytics-report-frequency",
        path: `${APP_PREFIX_PATH}/analytics/reports/frequency`,
        title: "sidenav.report-frequency",
        icon: BarChartOutlined,
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "analytics-report-comprehensive",
        path: `${APP_PREFIX_PATH}/analytics/reports/comprehensive`,
        title: "sidenav.report-comprehensive",
        icon: BarChartOutlined,
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "analytics-report-user-login",
        path: `${APP_PREFIX_PATH}/analytics/reports/user-login`,
        title: "sidenav.report-user-login",
        icon: BarChartOutlined,
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "analytics-report-audit-logs",
        path: `${APP_PREFIX_PATH}/analytics/reports/audit`,
        title: "sidenav.report-audit-logs",
        icon: BarChartOutlined,
        breadcrumb: true,
        submenu: [],
      },
    ],
  },
  {
    key: "obligation-management-section",
    path: `${APP_PREFIX_PATH}/`,
    title: "sidenav.obligation-management-section",
    icon: UnorderedListOutlined,
    breadcrumb: true,
    submenu: [
      {
        key: "my-obligation",
        path: `${APP_PREFIX_PATH}/`,
        title: "sidenav.my-obligation",
        icon: UnorderedListOutlined,
        breadcrumb: true,
        submenu: [
          {
            key: "my-obligation-time-based",
            path: `${APP_PREFIX_PATH}/my-obligation/time-based`,
            title: "sidenav.change-due-date-time",
            icon: FieldTimeOutlined,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "my-obligation-event-based",
            path: `${APP_PREFIX_PATH}/my-obligation/event-based`,
            title: "sidenav.change-due-date-events",
            icon: CalendarOutlined,
            breadcrumb: true,
            submenu: [],
          },
        ],
      },
      {
        key: "instance-obligation",
        path: `${APP_PREFIX_PATH}/instance-obligation`,
        title: "sidenav.compliance-view-task",
        icon: FileTextOutlined,
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "auditor-action",
        path: `${APP_PREFIX_PATH}/auditing-action`,
        title: "sidenav.auditor-action",
        icon: AuditOutlined,
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "compliance-approval",
        path: `${APP_PREFIX_PATH}/compliance-approval`,
        title: "sidenav.compliance-approval",
        icon: CheckCircleOutlined,
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "delegation",
        path: `${APP_PREFIX_PATH}/`,
        title: "sidenav.delegation",
        icon: UserOutlined,
        breadcrumb: true,
        submenu: [
          {
            key: "delegation-time-based",
            path: `${APP_PREFIX_PATH}/delegation/time-based`,
            title: "sidenav.change-due-date-time",
            icon: FieldTimeOutlined,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "delegation-event-based",
            path: `${APP_PREFIX_PATH}/delegation/event-based`,
            title: "sidenav.change-due-date-events",
            icon: CalendarOutlined,
            breadcrumb: true,
            submenu: [],
          },
        ],
      },
      {
        key: "due-date-manager",
        path: `${APP_PREFIX_PATH}/`,
        title: "sidenav.due-date-manager",
        icon: CalendarOutlined,
        breadcrumb: true,
        submenu: [
          {
            key: "due-date-manager-time-based",
            path: `${APP_PREFIX_PATH}/due-date-manager/time-based`,
            title: "sidenav.change-due-date-time",
            icon: FieldTimeOutlined,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "due-date-manager-event-based",
            path: `${APP_PREFIX_PATH}/due-date-manager/event-based`,
            title: "sidenav.change-due-date-events",
            icon: CalendarOutlined,
            breadcrumb: true,
            submenu: [],
          },
        ],
      },
    ],
  },
  {
    key: "application-settings",
    path: `${APP_PREFIX_PATH}/`,
    title: "sidenav.applicaiton-settings",
    icon: SettingOutlined,
    breadcrumb: true,
    submenu: [
      {
        key: "settings",
        path: `${APP_PREFIX_PATH}/`,
        title: "sidenav.settings",
        icon: SettingOutlined,
        breadcrumb: true,
        submenu: [
          {
            key: "company-management",
            path: `${APP_PREFIX_PATH}/company-management`,
            title: "sidenav.company-management",
            icon: BankOutlined,
            breadcrumb: true,
            submenu: [],
          },

          {
            key: "user-management",
            path: `${APP_PREFIX_PATH}/user-management`,
            title: "sidenav.user-management",
            icon: UserAddOutlined,
            breadcrumb: true,
            submenu: [],
          },
        ],
      },
    ],
  },
  {
    key: "client-settings",
    path: `${APP_PREFIX_PATH}/`,
    title: "sidenav.client-settings",
    icon: ScheduleOutlined,
    breadcrumb: true,
    submenu: [
      {
        key: "company-settings",
        path: `${APP_PREFIX_PATH}/`,
        title: "sidenav.company-settings",
        icon: CloudServerOutlined,
        breadcrumb: true,
        submenu: [
          {
            key: "team-management",
            path: `${APP_PREFIX_PATH}/team-management`,
            title: "sidenav.project-management",
            icon: ApartmentOutlined,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "cxo-management",
            path: `${APP_PREFIX_PATH}/cxo-management`,
            title: "sidenav.cxo-management",
            icon: AuditOutlined,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "contract-management",
            path: `${APP_PREFIX_PATH}/contract-management`,
            title: "sidenav.contract-management",
            icon: FileTextOutlined,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "obligation-management",
            path: `${APP_PREFIX_PATH}/obligation-management`,
            title: "sidenav.obligation-management",
            icon: UnorderedListOutlined,
            breadcrumb: true,
            submenu: [],
          },
        ],
      },
    ],
  },
  {
    key: "team-settings",
    path: `${APP_PREFIX_PATH}/`,
    title: "sidenav.team-settings",
    icon: TeamOutlined,
    breadcrumb: true,
    submenu: [
      {
        key: "team-settings-menu",
        path: `${APP_PREFIX_PATH}/`,
        title: "sidenav.team-settings",
        icon: TeamOutlined,
        breadcrumb: true,
        submenu: [
          {
            key: "obligation-mapping",
            path: `${APP_PREFIX_PATH}/obligation-mapping`,
            title: "sidenav.obligation-mapping",
            icon: LinkOutlined,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "team-obligation-user",
            path: `${APP_PREFIX_PATH}/team-obligation-user`,
            title: "sidenav.team-obligation-user",
            icon: UserOutlined,
            breadcrumb: true,
            submenu: [],
          },
        ],
      },
    ],
  },
  /** Header title only (not shown in sidebar); matches KCRA user profile routes. */
  {
    key: "user-profile-edit",
    path: `${APP_PREFIX_PATH}/user-profile/edit-profile`,
    title: "sidenav.edit-profile",
    breadcrumb: true,
    submenu: [],
  },
  {
    key: "user-profile-change-password",
    path: `${APP_PREFIX_PATH}/user-profile/change-password`,
    title: "sidenav.change-password",
    breadcrumb: true,
    submenu: [],
  },
];
var nav = [...componentsNavTree];

const navigationConfig = [...nav];

export default navigationConfig;
